"use client";

import { c as _c } from "react/compiler-runtime";
import Button from "@/components/ui/button";
import { SortableItem, SortableList } from "@/components/ui/sortable-list";
import { useOverviewLayout } from "@/contexts/overview-layout-context";
import { OVERVIEW_SECTIONS, PatientOverviewProps, useOverviewSectionAvailable } from "@/lib/overview-section-registry";
import { OverviewSection } from "@/types/overview-layout";
import EditableSectionFrame from "./editable-section-frame";
function EditViewHeader() {
  const $ = _c(15);
  const {
    actions,
    meta
  } = useOverviewLayout();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-caption text-foreground-secondary">Drag to reorder sections. Use the X to hide a section. Hidden sections appear in the sidebar.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== actions.resetToDefaults) {
    t1 = <Button type="button" variant="ghost" size="sm" onClick={actions.resetToDefaults}>Reset to defaults</Button>;
    $[1] = actions.resetToDefaults;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== actions.cancelEdit) {
    t2 = <Button type="button" variant="secondary" size="sm" onClick={actions.cancelEdit}>Cancel</Button>;
    $[3] = actions.cancelEdit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== actions) {
    t3 = () => void actions.save();
    $[5] = actions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !meta.hasChanges;
  let t5;
  if ($[7] !== meta.isSaving || $[8] !== t3 || $[9] !== t4) {
    t5 = <Button type="button" variant="primary" size="sm" onClick={t3} disabled={t4} isLoading={meta.isSaving} loadingText="Saving...">Save</Button>;
    $[7] = meta.isSaving;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t5) {
    t6 = <div className="flex items-center justify-between gap-3 rounded-lg border border-border bg-background-secondary/40 px-3 py-2">{t0}<div className="flex items-center gap-3">{t1}{t2}{t5}</div></div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
export default function OverviewTabEditView(props) {
  const $ = _c(28);
  const {
    state,
    actions
  } = useOverviewLayout();
  const isAvailable = useOverviewSectionAvailable();
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== actions || $[1] !== isAvailable || $[2] !== props || $[3] !== state.draft) {
    let t6;
    if ($[11] !== isAvailable) {
      t6 = p => p.visible && isAvailable(p.section);
      $[11] = isAvailable;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    const visible = state.draft.filter(t6).sort(_temp);
    const visibleSectionIds = visible.map(_temp2);
    t4 = "space-y-6";
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <EditViewHeader />;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    T0 = SortableList;
    t0 = visibleSectionIds;
    if ($[14] !== actions) {
      t1 = ids => actions.reorder(ids as OverviewSection[]);
      $[14] = actions;
      $[15] = t1;
    } else {
      t1 = $[15];
    }
    t2 = "space-y-6";
    let t7;
    if ($[16] !== props) {
      t7 = p_1 => <SortableItem key={p_1.section} id={p_1.section}><EditableSectionFrame section={p_1.section}>{OVERVIEW_SECTIONS[p_1.section].render(props)}</EditableSectionFrame></SortableItem>;
      $[16] = props;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t3 = visible.map(t7);
    $[0] = actions;
    $[1] = isAvailable;
    $[2] = props;
    $[3] = state.draft;
    $[4] = T0;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    T0 = $[4];
    t0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[18] !== T0 || $[19] !== t0 || $[20] !== t1 || $[21] !== t2 || $[22] !== t3) {
    t6 = <T0 items={t0} onReorder={t1} className={t2}>{t3}</T0>;
    $[18] = T0;
    $[19] = t0;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
function _temp2(p_0) {
  return p_0.section;
}
function _temp(a, b) {
  return a.position - b.position;
}